import { authenticatedFetch } from "./auth.api";

const BASE_URL = process.env.REACT_APP_ZVB_URL ;

// API to update service status
export const updateVin = async (vehicleId, vin) => {
  const response = await authenticatedFetch(
    `${BASE_URL}/vin/update/${vehicleId}/${vin}`,
    {
      method: "PUT",
      body: JSON.stringify({ vin }),
    }
  );

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || "Failed to update service status");
  }

  return response.json();
};